import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { Button } from "src/components/Button";
import { ReactComponent as PlusIcon } from "src/assets/icons/plus-big.svg";
import { ReactComponent as MinusIcon } from "src/assets/icons/minus.svg";
import { IQuestionAndAnswer } from "./types";

const ICON_SIZE = 28;

export const QuestionsAndAnswersItem: FC<IQuestionAndAnswer> = ({
  question,
  answer,
}) => {
  const { t } = useTranslation();

  const [isVisibleAnswer, setIsVisibleAnswer] = useState(false);

  const handleToggleAnswer = () => {
    setIsVisibleAnswer(!isVisibleAnswer);
  };

  const questionText =
    typeof question === "string" ? question : t(question.i18nKey);
  const answerText = typeof answer === "string" ? answer : t(answer.i18nKey);

  return (
    <div className="max-w-200 w-full px-8 py-5 mx-auto border rounded-20">
      <Button
        className="!justify-start gap-5 !brightness-100"
        onClick={handleToggleAnswer}
      >
        {isVisibleAnswer ? (
          <MinusIcon
            className="flex-shrink-0"
            width={ICON_SIZE}
            height={ICON_SIZE}
          />
        ) : (
          <PlusIcon
            className="flex-shrink-0"
            width={ICON_SIZE}
            height={ICON_SIZE}
          />
        )}

        <span className="font-bold text-start">{questionText}</span>
      </Button>

      <div
        className={cn("transition-opacity duration-1000", {
          "opacity-0": !isVisibleAnswer,
          "opacity-100 mt-10": isVisibleAnswer,
        })}
      >
        {isVisibleAnswer && (
          <pre className="text-justify">
            <p>{answerText}</p>
          </pre>
        )}
      </div>
    </div>
  );
};
